import { darken, lighten } from '@mui/system'
import { getMixedColorPalette } from '../../../shared/utils/colors-utils'
import type { IGaiaReportPaletteOverrides } from '../shared-services/public-reports.model'

export const GAIA_REPORT_CHART_SERIES_COUNT = 6

export interface IGaiaReportColorPalette {
  main: string
  light: string
  dark: string
  veryLight: string
  veryDark: string
}

/** Same lighten/darken coefficients as before optional overrides existed (0.3 / 0.6). */
export function buildGaiaReportColorPalette(
  organisationColor: string,
  overrides?: IGaiaReportPaletteOverrides | null
): IGaiaReportColorPalette {
  const base = organisationColor
  return {
    main: base,
    light: overrides?.light ?? lighten(base, 0.3),
    dark: overrides?.dark ?? darken(base, 0.3),
    veryLight: overrides?.veryLight ?? lighten(base, 0.6),
    veryDark: overrides?.veryDark ?? darken(base, 0.6),
  }
}

/**
 * Multi-series chart colours (donuts, stacked bars, emissions-over-time line).
 * Defaults match getMixedColorPalette(organisationColor); optional per-index overrides in paletteOverrides.barChartColors.
 */
export function getReportChartSeriesColors(
  organisationColor: string,
  overrides?: IGaiaReportPaletteOverrides | null
): string[] {
  const base = getMixedColorPalette(organisationColor)
  const custom = overrides?.barChartColors
  if (!custom?.length) return base
  return base.map((c, i) => {
    const v = custom[i]
    if (typeof v === 'string' && /^#[0-9A-Fa-f]{6}$/i.test(v.trim())) return v.trim().toLowerCase()
    return c
  })
}
